import React, { FC } from 'react';
import { Cancel } from '@mui/icons-material';
import { Dialog, IconButton } from '@mui/material';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import * as Styles from './ConfirmModal.styles';

interface ConfirmModalProps {
  open: boolean;
  close: () => void;
  confirm: () => void;
  confirmText: string;
  buttonText: string;
  cancelText?: string;
}

const ConfirmModal: FC<ConfirmModalProps> = ({ open, close, confirm, confirmText, buttonText, cancelText }) => {
  const [language] = useLanguage();

  const handleConfirm = (): void => {
    confirm();
    close();
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="md">
      <Styles.Container>
        <IconButton sx={{ position: 'absolute', top: '1rem', right: '1rem' }} onClick={close}>
          <Cancel />
        </IconButton>
        <h2>{language.ConfirmModal.confirm}</h2>
        <Styles.Message>{confirmText}</Styles.Message>
        <Button onClick={handleConfirm} style={{ margin: '10px' }}>
          {buttonText}
        </Button>
        {cancelText && (
          <Button onClick={close} style={{ margin: '10px' }}>
            {cancelText}
          </Button>
        )}
      </Styles.Container>
    </Dialog>
  );
};

export default ConfirmModal;
